/* <soh-cart-drawer> and <soh-cart-items> (cart page). Section id: cart-drawer / main-cart.
   Shipping rule (display only; real rates live in Shopify shipping settings): free when the cart has any subscription line, else $5.95. */
class SohCartItems extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => {
      const line = e.target.closest('[data-line]'); if (!line) return;
      const idx = Number(line.dataset.line), input = line.querySelector('.soh-qty__input');
      if (e.target.closest('[data-qty]')) this.update(idx, Math.max(0, Number(input.value) + Number(e.target.closest('[data-qty]').dataset.qty)));
      else if (e.target.closest('[data-remove]')) this.update(idx, 0);
      else if (e.target.closest('[data-switch-plan]')) this.update(idx, Number(input.value), e.target.closest('[data-switch-plan]').dataset.switchPlan);
      else if (e.target.closest('[data-upsell-variant]')) this.upsell(e.target.closest('[data-upsell-variant]'));
    });
    this.addEventListener('change', (e) => { const line = e.target.closest('[data-line]'); if (line && e.target.matches('.soh-qty__input')) this.update(Number(line.dataset.line), Number(e.target.value)); });
  }
  sections() { const page = this.closest('[data-cart-page]'); return page ? [page.dataset.sectionId, 'cart-drawer', 'cart-icon-bubble'] : ['cart-drawer', 'cart-icon-bubble']; }
  async update(line, quantity, sellingPlan) {
    this.classList.add('is-loading');
    try { const res = await SOH.cart.change(line, quantity, sellingPlan, this.sections()); SOH.renderSections(res.sections); SOH.emit('soh:cart:updated', { cart: res }); }
    catch (e) { const err = this.querySelector('[data-cart-error]'); if (err) { err.textContent = e.message; err.hidden = false; } }
    finally { this.classList.remove('is-loading'); }
  }
  /* "Go for 3 boxes": swap the 1-box line for the 3-box variant + 3-month plan */
  async upsell(btn) {
    this.classList.add('is-loading');
    try {
      await SOH.cart.change(Number(btn.dataset.line), 0, undefined, []);
      const res = await SOH.cart.add({ id: btn.dataset.upsellVariant, quantity: 1, selling_plan: btn.dataset.upsellPlan || undefined }, this.sections());
      SOH.renderSections(res.sections); SOH.emit('soh:cart:updated', {});
    } catch (e) { const err = this.querySelector('[data-cart-error]'); if (err) { err.textContent = e.message; err.hidden = false; } }
    finally { this.classList.remove('is-loading'); }
  }
}
customElements.define('soh-cart-items', SohCartItems);

class SohCartDrawer extends HTMLElement {
  connectedCallback() {
    this.overlay = this.querySelector('.soh-overlay');
    this.panel = this.querySelector('.soh-cart-drawer__panel');
    SOH.on('soh:cart:open', () => this.open());
    this.addEventListener('click', (e) => { if (e.target === this.overlay || e.target.closest('[data-cart-close]')) this.close(); });
    this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
    document.addEventListener('click', (e) => { const b = e.target.closest('[data-cart-open]'); if (b && this.isConnected && !document.querySelector('[data-cart-page]')) { e.preventDefault(); this.open(); } });
  }
  open() {
    this.opener = document.activeElement;
    this.classList.add('is-open'); this.overlay.classList.add('is-open'); this.panel.setAttribute('aria-hidden', 'false');
    SOH.lockScroll(true); this.release = SOH.trapFocus(this.panel);
  }
  close() {
    this.classList.remove('is-open'); this.overlay.classList.remove('is-open'); this.panel.setAttribute('aria-hidden', 'true');
    SOH.lockScroll(false); this.release && this.release(); this.opener && this.opener.focus();
  }
}
customElements.define('soh-cart-drawer', SohCartDrawer);
